import React from 'react';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Painting } from '../models/Painting';
import { CardActionArea, Stack, Box } from '@mui/material';

export default function PaintingThumbnail({painting, setFocusedPainting, textSize = 1}: {painting: Painting, setFocusedPainting: React.Dispatch<React.SetStateAction<Painting>>, textSize?: number}) {

  return (
    <Stack sx={{
      width: '100%',
      maxWidth: '100%',
      margin: 1,
      padding: 1
    }}>
      <Box sx={{
        // Simple container without frame
        position: 'relative',
        width: '100%',
        maxWidth: '100%',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))'
      }}>
        {/* Container for the painting with minimal white space */}
        <Box sx={{
          width: '100%', // Full width to minimize white space
          height: '100%', // Full height to minimize white space
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <CardActionArea
            onClick={() => setFocusedPainting(painting)}
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <CardMedia
              component="img"
              image={painting.thumb}
              alt={`${painting.name} ${painting.description}`}
              sx={{
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain', // Preserve aspect ratio without cropping
                transition: 'transform 0.2s ease-in-out',
                border: '2px solid white', // Small white border
                '&:hover': {
                  transform: 'scale(1.02)'
                }
              }}
            />
          </CardActionArea>
        </Box>
      </Box>
      <Typography
        fontFamily={"Grenze"}
        align="center"
        fontSize={`${Math.max(0.8, 1.2 * textSize)}rem`}
        sx={{
          mt: 1,
          maxWidth: '100%',
          wordWrap: 'break-word',
          overflowWrap: 'break-word'
        }}
      >
        {painting.name}
      </Typography>
    </Stack>
  );
}